export const servicePayouts = [
	// Выплаты на карту
	{
		name: 'Выплаты на банковские карты',
		location: 'Выплаты на карту',
		url: '/payouts#block1',
	},
	{
		name: 'Cервис массовых выплат для бизнеса поможет быстро переводить:',
		location: 'Выплаты на карту',
		url: '/payouts#block2',
	},
	{
		name: 'Рассчитывайтесь с клиентами за несколько секунд',
		location: 'Выплаты на карту',
		url: '/payouts#block3Title1',
	},
	{
		name: 'Выгружайте данные по операциям в любое время',
		location: 'Выплаты на карту',
		url: '/payouts#block3Title2',
	},
	{
		name: 'Как подключить массовые выплаты на карты',
		location: 'Выплаты на карту',
		url: '/payouts#block4',
	},
	// Выплаты через личный кабинет
	{
		name: 'Выплаты на карту через личный кабинет CloudPayments',
		location: 'Выплаты на карту: Выплаты через личный кабинет',
		url: '/payouts/payouts-lk#block1',
	},
	{
		name: 'Создавайте выплаты быстро и просто',
		location: 'Выплаты на карту: Выплаты через личный кабинет',
		url: '/payouts/payouts-lk#block1Title2',
	},
	{
		name: 'Рассчитывайтесь с клиентами за несколько секунд',
		location: 'Выплаты на карту: Выплаты через личный кабинет',
		url: '/payouts/payouts-lk#block2',
	},
	{
		name: 'Отслеживайте сделки в личном кабинете',
		location: 'Выплаты на карту: Выплаты через личный кабинет',
		url: '/payouts/payouts-lk#block3',
	},
	{
		name: 'Как подключить выплаты через личный кабинет',
		location: 'Выплаты на карту: Выплаты через личный кабинет',
		url: '/payouts/payouts-lk#block4',
	},
	// Выплаты по API
	{
		name: 'Массовые выплаты на банковские карты по API',
		location: 'Выплаты на карту: Выплаты по API',
		url: '/payouts/payouts-api#block1',
	},
	{
		name: 'Когда будет полезен сервис массовых выплат?',
		location: 'Выплаты на карту: Выплаты по API',
		url: '/payouts/payouts-api#block2',
	},
	{
		name: 'Преимущества массовых выплат по API с CloudPayments',
		location: 'Выплаты на карту: Выплаты по API',
		url: '/payouts/payouts-api#block3',
	},
	{
		name: 'Моментальные расчеты с&nbsp;клиентами',
		location: 'Выплаты на карту: Выплаты по API',
		url: '/payouts/payouts-api#block3Title1',
	},
	{
		name: 'Удобный способ оплаты',
		location: 'Выплаты на карту: Выплаты по API',
		url: '/payouts/payouts-api#block3Title2',
	},
	{
		name: 'Доступные данные по&nbsp;всем операциям',
		location: 'Выплаты на карту: Выплаты по API',
		url: '/payouts/payouts-api#block3Title3',
	},
	{
		name: 'Как это работает?',
		location: 'Выплаты на карту: Выплаты по API',
		url: '/payouts/payouts-api#block4',
	},

];
